export default "__VITE_ASSET__ba96fc6f__"